module.exports = __webpack_public_path__ + "static/media/DUTUDIF_baseline_diagnostics.022f688f.png";